export const StructuredData = {
  organization: {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "91直播平台资讯站",
    url: "",
    description: "91直播平台相关资讯、常见问题、版本辨别与使用说明",
    contactPoint: {
      "@type": "ContactPoint",
      email: "contact@91zhibo-info.example.com",
      contactType: "customer service",
      availableLanguage: ["Chinese"],
    },
  },
  website: {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "91直播平台资讯站",
    url: "",
    description: "91直播平台相关资讯、常见问题、版本辨别与使用说明，帮助用户识别虚假页面、恶意下载和隐私风险。",
    inLanguage: "zh-CN",
  },
  faqPage: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "91直播平台是什么？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "91直播平台是一款集娱乐、社交、互动于一体的综合性直播产品，提供实时弹幕、礼物打赏、连麦互动等多种互动方式。",
        },
      },
      {
        "@type": "Question",
        name: "如何识别91直播平台虚假页面？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "可通过域名验证、页面特征观察、功能完整性对比、联系方式核实以及用户评价参考五大要点识别虚假页面。",
        },
      },
      {
        "@type": "Question",
        name: "91直播平台账户被盗怎么办？",
        acceptedAnswer: {
          "@type": "Answer",
          text: "立即修改密码、强制下线所有设备、检查账户绑定信息是否被篡改，并联系官方客服报告异常情况。",
        },
      },
    ],
  },
};